export default "__VITE_ASSET__OZLBdAha__"